import { Directive, EventEmitter, OnDestroy, Output, Self } from '@angular/core';
import { removeJSDateLocalOffset } from '@app/shared/common/timing/date-helpers';
import { DateTime } from 'luxon';
import { BsDatepickerInlineDirective } from 'ngx-bootstrap/datepicker';
import { BehaviorSubject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, pluck, switchMap } from 'rxjs/operators';
import { getDatePickerComponentOnShown$ } from './inline-date-picker-on-shown';

interface BsDatePickerStoreView {
    date: Date;
    mode: 'day' | 'month' | 'year';
}

interface BsDatePickerStoreData {
    view: BsDatePickerStoreView;
}

@Directive({
    selector: 'bs-datepicker-inline[appDatePickerViewChanged]',
})
export class InlineDatePickerOnViewChangeDirective implements OnDestroy {
    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output('appDatePickerViewChanged') viewChanged = new EventEmitter<Date>();

    private _storeSubscription$: Subscription;

    constructor(@Self() datePicker: BsDatepickerInlineDirective) {
        const datepickerComponentShown$ = getDatePickerComponentOnShown$(datePicker);

        const switchToDatePickerStore$ = switchMap((instance: any) => instance._store.source as BehaviorSubject<BsDatePickerStoreData>);
        const pluckView$ = pluck<BsDatePickerStoreData, BsDatePickerStoreView>('view');
        const ignoreWhenViewIsNotDay$ = filter(({ mode }: BsDatePickerStoreView) => mode === 'day');
        const mapStartOfDay$ = map(({ date }: BsDatePickerStoreView) => removeJSDateLocalOffset(date).startOf('day'));
        const ignoreUntilDayChanges$ = distinctUntilChanged((x: DateTime, y) => (x == null && y == null) || (x && y && x.equals(y)));

        this._storeSubscription$ = datepickerComponentShown$
            .pipe(
                switchToDatePickerStore$,
                pluckView$,
                ignoreWhenViewIsNotDay$,
                mapStartOfDay$,
                ignoreUntilDayChanges$,
            )
            .subscribe(startOfSelectedDay => this.viewChanged.next(startOfSelectedDay.toJSDate()));
    }

    ngOnDestroy(): void {
        this._storeSubscription$.unsubscribe();
    }
}
